import CustomImage from "./CustomImage";
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ResizableImageTemplate from "./tiptap-templates/ResizableImageTemplate";
export default CustomImage.extend({
  name: 'ResizableImage',
  addAttributes() {
    var _this$parent;
    return {
      ...((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)),
      width: {
        default: 'auto',
        renderHTML: attributes => {
          return {
            width: attributes.width
          };
        }
      },
      height: {
        default: 'auto',
        renderHTML: attributes => {
          return {
            height: attributes.height
          };
        }
      }
    };
  },
  addNodeView() {
    return VueNodeViewRenderer(ResizableImageTemplate);
  }
});